<template>
    <div class="fiveIcon">
        <div class="indexContainer">
            <el-divider class="indexTitle" v-if="val.title">
                <div class="indexTitleMain">
                    <h3 v-if="val.languageId = 1">{{val.title ? val.title : ''}}</h3><br/>
                    <h4>{{val.summary}}</h4>
                </div>
            </el-divider>
            <div class="MedicalMain">
                <el-row>
                    <el-col :span="4" v-for="(item, index) in MedicalMainList" :key="index">
                        <div @click="rowClick(item)">
                            <img :src="item.imgUrl" :alt="item.imgAlt">
                            <p>{{item.title}}</p>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    val: {}
  },
    data(){
        return{
            MedicalMainList:[],
        }
    },
    methods:{
        rowClick(row){
          if(row.linkUrl) {
            window.open(row.linkUrl, '_self');
          }
        },
    },
    created() {
      this.MedicalMainList = this.val.attaches;
    },
    watch: {
      val(val) {
      this.MedicalMainList = this.val.attaches;
      }
    }
}
</script>
<style lang="less" scoped>
.fiveIcon{
    .MedicalMain{
        width: 100%;
        vertical-align: middle;
        .el-col-4{
            align-content:center;
            padding:0;
            box-sizing: border-box;
            width: 20%;
        }
        .el-col-4:hover{
            img{
                opacity:.8;
            }
            p{
                color: #d11a2e;
            }
        }
        img{
            width: 40px;
            height: 40px;
            border-radius: 40px;
            border:1px solid #ccc;
        }

    }
    @media only screen and (min-width: 768px){
        .MedicalMain{
            .el-col-4{
                padding:20px 0;
            }
            img{
                width: 62px;
                height: 62px;
            }
        }


    }
}
</style>



// WEBPACK FOOTER //
// src/components/item/patch21.vue